import { Card, CardContent } from "@/components/ui";
import { cn, formatCurrency } from "@/lib/utils";
import type { Product } from "@/types";

interface ProductCardProps {
  product: Product;
  onClick: () => void;
  currencySymbol: string;
}

export function ProductCard({
  product,
  onClick,
  currencySymbol,
}: ProductCardProps) {
  const defaultVariant =
    product.variants?.find((v) => v.isDefault) ?? product.variants?.[0];
  const price = defaultVariant?.price ?? 0;
  const isCustomizable =
    (product.attributes?.length ?? 0) > 0 ||
    (product.variants?.length ?? 0) > 1;

  return (
    <Card
      role="button"
      tabIndex={0}
      data-testid="product-card"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className={cn(
        "relative cursor-pointer overflow-hidden transition-all hover:-translate-y-0.5 hover:shadow-md",
        !product.isActive && "opacity-50",
      )}
    >
      <CardContent className="flex min-h-[88px] flex-col items-center justify-center gap-1.5 p-3 text-center">
        <p className="line-clamp-2 text-sm font-semibold leading-tight">
          {product.name}
        </p>
        <p className="text-base font-bold text-primary">
          {formatCurrency(price, currencySymbol)}
        </p>
        {isCustomizable && (
          <span className="rounded-full bg-primary/90 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary-foreground">
            Options
          </span>
        )}
      </CardContent>
    </Card>
  );
}
